import _extends from "@babel/runtime/helpers/extends";
import { CELL_TYPES, DEFAULT_EMPTY_PLACEHOLDER, PLACEHOLDER_SAFE_CELL_TYPES } from "./constants";
function isCellContentsEmpty(rowData, colId, computedCellProps) {
  return rowData[colId] !== 0 && !rowData[colId] && !computedCellProps;
}
function getCellType(cellType, _ref, rowData, emptyPlaceholderText) {
  var colId = _ref.colId,
    getCellProps = _ref.getCellProps;
  var computedCellProps = typeof getCellProps === "function" && getCellProps(colId, rowData);
  if (isCellContentsEmpty(rowData, colId, computedCellProps)) {
    var _ref2 = PLACEHOLDER_SAFE_CELL_TYPES.includes(cellType) ? CELL_TYPES[cellType] : CELL_TYPES.text,
      EmptyComponent = _ref2.component;
    return {
      as: EmptyComponent,
      children: emptyPlaceholderText || DEFAULT_EMPTY_PLACEHOLDER
    };
  }
  var _ref3 = CELL_TYPES[cellType] || CELL_TYPES.text,
    Component = _ref3.component,
    defaultGetCellProps = _ref3.getCellProps;
  var getCellPropsFn = getCellProps || defaultGetCellProps;
  return _extends({}, getCellPropsFn(colId, rowData), {
    as: Component
  });
}
export default getCellType;